import type { ReactiveVar } from "@apollo/client";
import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

const INITIAL_STATE = false;

const resetIsFullscriptJsVar = () => {
  isFullscriptJsVar(INITIAL_STATE);
};

const isFullscriptJsVar: ReactiveVar<boolean> = makeFSVar(
  INITIAL_STATE,
  "useIsFullscriptJsVar",
  resetIsFullscriptJsVar
);

const setIsFullscriptJsVar = (newVal: boolean) => {
  isFullscriptJsVar(newVal);
};

const useIsFullscriptJsVar = (): boolean => {
  return useReactiveVar(isFullscriptJsVar);
};

export { useIsFullscriptJsVar, setIsFullscriptJsVar, isFullscriptJsVar };
